import { message, PageHeader, Select, Space, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { SegmentedItem, SelectInsumosItem, SelectItem, TableItem, round10Decimals, ButtonItem } from "../../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { EditOutlined, EyeOutlined, StopOutlined, SwapOutlined, TagOutlined, WarningOutlined } from "@ant-design/icons";
import VerLote from "../VerLote/VerLote";
import EditarLote from "../EditarLote/EditarLote";
import ModalEtiquetasLote from "../ModalEtiquetasLote/ModalEtiquetasLote";
import ModalBajaLote from "./ModalBajaLote";

moment.locale("es");

const { Option } = Select;

class LotesProducto extends Component {
    state = {
        loading: false,
        objetoProyectos: [],
        todasProyectos: [],
        objetoInsumos: [],
        todasInsumos: [],
        todasLotes: [],
        proyectoId: this.props.location.state.proyectoId ? this.props.location.state.proyectoId : 0,
        insumoId: this.props.location.state.id,
        modalVerLote: false,
        modalVerLoteId: null,
        modalEditarLote: false,
        modalEditarLoteId: null,
        modalEtiquetasLote: false,
        modalEtiquetasLoteId: null,
        modalEtiquetasLoteNumero: null,
        modalBajaLote: false,
        modalBajaLoteId: null,
        valor: 1, // 1: Activos, 2: Ocupados, 3: Todos, 4: Dados de baja (solo con la opcion de empresa)
        vehiculo: false,
        rangosLeyenda: [],
        usarColores: false,
    };

    async consultarConfiguracionLotes() {
        axios
            .post(
                "lotes/selectConfiguracionLotes",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        usarColores: res.data.usarColoresLotes,
                        rangosLeyenda: res.data.rangosLotes || [],
                    });
                }
            });
    }

    async componentDidMount() {
        this.setState({ loading: true });
        await axios
            .post(
                "proyectos/selectProyectos",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({ todasProyectos: res.data });
                    this.setState({
                        objetoProyectos: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                    });
                }
            });
        await this.consultarLotesInsumo(this.state.valor)
        this.consultarConfiguracionLotes();
        this.setState({ loading: false });
    }

    async consultarLotesInsumo(value) {
        this.setState({ loading: true });
        await axios
            .post(
                "lotes/selectLotesInsumos",
                { empresaId: this.props.empresaId, insumoId: this.state.insumoId, proyectoId: this.state.proyectoId, valor: value },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasLotes: res.data.lotes,
                        vehiculo: res.data.vehiculo,
                        loading: false,
                    });
                } else {
                    this.setState({ todasLotes: [], loading: false })
                    message.info("No se encontraron lotes para este insumo y proyecto.");
                }
            });
    }

    onChangeProyectoInsumo(insumoId, proyectoId) {
        this.setState({ loading: true })
        axios
            .post(
                "lotes/selectLotesInsumos",
                { empresaId: this.props.empresaId, insumoId, proyectoId, valor: this.state.valor },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasLotes: res.data.lotes,
                        vehiculo: res.data.vehiculo,
                    });
                } else {
                    this.setState({ todasLotes: [] })
                    message.info("No se encontraron lotes para este insumo y proyecto.");
                }
                this.setState({ loading: false, insumoId, proyectoId });
            });

    }


    handleMenuClick(e) {
        if (e.key === '1') {
            this.abrirAgregarInventario()
        }
        if (e.key === '2') {
            this.abrirTraspasoEntreAlmacenes()
        }
        if (e.key === '3') {
            this.abrirProductosAlCosto()
        }
    }

    verLote(id) {
        this.setState({
            modalVerLote: true,
            modalVerLoteId: id
        })
    }

    cerrarVerLote() {
        this.setState({
            modalVerLote: false,
            modalVerLoteId: null
        })
        this.consultarLotesInsumo(this.state.valor);
    }

    editarLote(id) {
        this.setState({
            modalEditarLote: true,
            modalEditarLoteId: id
        })
    }

    cerrarEditarLote() {
        this.setState({
            modalEditarLote: false,
            modalEditarLoteId: null
        })
        this.consultarLotesInsumo(this.state.valor);
    }

    abrirEtiquetasLote(record) {
        this.setState({
            modalEtiquetasLote: true,
            modalEtiquetasLoteId: record._id,
            modalEtiquetasLoteNumero: record.numero,
        })
    }

    cerrarEtiquetasLote() {
        this.setState({
            modalEtiquetasLote: false,
            modalEtiquetasLoteId: null,
            modalEtiquetasLoteNumero: null,
        })
    }

    abrirBajaLote(id) {
        this.setState({
            modalBajaLote: true,
            modalBajaLoteId: id,
        })
    }

    cerrarBajaLote(huboCambios) {
        this.setState({
            modalBajaLote: false,
            modalBajaLoteId: null,
        })
        if (huboCambios) this.consultarLotesInsumo(this.state.valor);
    }

    getIndiceRangoCaducidad(caducidad) {
        if (!caducidad || !this.state.usarColores || this.state.rangosLeyenda.length === 0) {
            return null;
        }

        const diasRestantes = moment(caducidad).diff(moment(), 'days');
        const rangosOrdenados = [...this.state.rangosLeyenda].sort((a, b) => a.tope - b.tope);

        for (let i = 0; i < rangosOrdenados.length; i++) {
            if (diasRestantes <= rangosOrdenados[i].tope) {
                return i;
            }
        }

        return null;
    }

    atras() {
        this.props.history.goBack();
    }

    render() {

        const coloresFijos = [
            'rgba(236, 251, 241, 1)',
            'rgba(223, 247, 230, 1)',
            'rgba(255, 244, 204, 1)',
            'rgba(255, 226, 204, 1)',
            'rgba(255, 214, 214, 1)',
        ];

        const estadosLeyendaDinamicos = this.state.usarColores
            ? this.state.rangosLeyenda.map((rango, index) => ({
                color: rango.color || coloresFijos[index] || 'rgba(200, 200, 200, 1)',
                label: rango.nombre,
                key: `rango-${index}`,
                tope: rango.tope,
            }))
            : [];

        const cssFilasCaducidad = this.state.usarColores
            ? [...this.state.rangosLeyenda]
                .sort((a, b) => a.tope - b.tope)
                .map((rango, index) => {
                    const color = rango.color || coloresFijos[index] || 'rgba(200, 200, 200, 1)';
                    return `
                .fila-caducidad-lote-producto-${index} > td {
                    background-color: ${color} !important;
                }

                .fila-caducidad-lote-producto-${index}:hover > td {
                    background-color: ${color} !important;
                }
            `;
                })
                .join("\n")
            : "";

        const columns = [
            {
                title: "Numero",
                dataIndex: "numero",
                key: "numero",
                width: "10%",
            },
            {
                title: "Fecha",
                dataIndex: "createdAt",
                responsive: ["md"],
                key: "createdAt",
                render: (value) => moment(value).locale("es").format("DD/MM/YYYY"),
                width: "10%",
            },
            {
                title: "Caducidad",
                dataIndex: "caducidad",
                responsive: ["md"],
                key: "caducidad",
                sorter: (a, b) => {
                    if (!a.caducidad) return 1;
                    if (!b.caducidad) return -1;
                    if (moment(a.caducidad).isBefore(moment(b.caducidad))) {
                        return -1;
                    }
                    if (moment(a.caducidad).isAfter(moment(b.caducidad))) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => value ? moment(value).locale("es").format("DD/MM/YYYY") : "-",
                width: "10%",
            },
            // {
            //     title: "Concepto",
            //     dataIndex: "concepto",
            //     responsive: ["md"],
            //     key: "concepto",
            //     width: "15%",
            //     buscar: "concepto",
            // },
            ...(this.props.taxidermia ? [{
                title: "Piezas",
                dataIndex: "piezas",
                responsive: ["md"],
                key: "piezas",
                render: (value) => {
                    if (Array.isArray(value) && value.length > 0) {
                        let tags = []
                        value.forEach((pieza, index) => {
                            if (pieza.cantdad !== pieza.cantidadVendida) {
                                if (pieza.estado === 1) {
                                    tags.push(
                                        <Tag key={index} color="blue" className="square-tag">
                                            {pieza?.descripcion?.slice(0, 4)}
                                        </Tag>
                                    )
                                } else if (pieza.estado === 0) {
                                    tags.push(
                                        <Tag key={index} color="red" className="square-tag">
                                            {pieza?.descripcion?.slice(0, 4)}
                                        </Tag>
                                    )
                                }
                            }
                        });
                        return tags
                    } else {
                        return null
                    }
                },
                width: "15%",
            },
            {
                title: "Cliente",
                dataIndex: "clienteNombre",
                responsive: ["md"],
                key: "clienteNombre",
                width: "15%",
                buscar: "clienteNombre",
            },
            ]
                : []),
            ...(this.state.vehiculo ? [
                {
                    title: "Color",
                    dataIndex: "color",
                    responsive: ["md"],
                    key: "color",
                    width: "12%",
                    buscar: "color",
                },
                {
                    title: "NIV",
                    dataIndex: "niv",
                    responsive: ["md"],
                    key: "niv",
                    width: "15%",
                    buscar: "niv",
                },

            ]
                : []),
            {
                title: "Proyecto",
                dataIndex: "proyecto",
                responsive: ["md"],
                key: "proyecto",
                render: (value) => value.nombre,
                width: "10%",
            },
            {
                title: "Cantidad",
                dataIndex: "cantidad",
                key: "cantidad",
                sorter: (a, b) => {
                    if (a.cantidad < b.cantidad) {
                        return -1;
                    }
                    if (a.cantidad > b.cantidad) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => round10Decimals(value).toFixed(4),
                width: "6%",
            },
            {
                title: "Ocupado",
                dataIndex: "cantidadVendida",
                key: "cantidadVendida",
                sorter: (a, b) => {
                    if (a.cantidadVendida < b.cantidadVendida) {
                        return -1;
                    }
                    if (a.cantidadVendida > b.cantidadVendida) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => round10Decimals(value).toFixed(4),
                align: "right",
                width: "6%",
            },
            {
                title: "Saldo",
                dataIndex: "saldo",
                key: "saldo",
                sorter: (a, b) => {
                    if (a.saldo < b.saldo) {
                        return -1;
                    }
                    if (a.saldo > b.saldo) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => round10Decimals(value).toFixed(4),
                width: "6%",
            },
            {
                title: "Usuario",
                dataIndex: "usuario",
                responsive: ["md"],
                key: "usuario",
                render: (value) => value.nombre,
                width: "10%",
            },

            {
                title: "Estados",
                key: "estados",
                align: "center",
                render: (value, record) => (
                    <Space size="small" direction="horizontal">
                        {record.etapaNombre &&
                            <Tag color="blue">
                                {record.etapaNombre}
                            </Tag>
                        }
                        {record.cotizacionNumero &&
                            <Tag color="orange">
                                {record.cotizacionNumero}
                            </Tag>
                        }
                        {record.dadoDeBaja &&
                            <Tooltip title={`${record.fechaBaja ? moment(record.fechaBaja).format("DD/MM/YYYY") + " - " : ""}${record.motivoBaja || ""}`}>
                                <Tag color="red">Dado de baja</Tag>
                            </Tooltip>
                        }
                        {record.ventaId &&
                            <Tag color="green">
                                V {record.ventaEstadoPago === 0 ? " No Pagada" : (record.ventaEstadoPago === 3 ? " Pagada" : " Parcialmente Pagada")}
                            </Tag>
                        }

                        {this.props.taxidermia && (!record.archivos || record.archivos?.length === 0) &&
                            <Tag color="orange" style={{ display: 'flex', alignItems: 'center', height: '1.4rem', fontSize: 12, padding: '0 6px' }}>
                                <WarningOutlined />
                            </Tag>
                        }

                    </Space>
                ),
                width: "15%",
            },
            {
                title: "Acción",
                key: "accion",
                align: "center",
                render: (value, record, index) => (
                    <Space size="small" direction="horizontal">
                        <Tooltip title="Ver detalles lote" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                azul
                                icon={<EyeOutlined />}
                                key={index.toString()}
                                onClick={() => this.verLote(value._id)}
                            >
                            </ButtonItem>
                        </Tooltip>
                        <Tooltip title="Imprimir etiqueta" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                morado
                                icon={<TagOutlined />}
                                key={index.toString()}
                                onClick={() => this.abrirEtiquetasLote(record)}
                            >
                            </ButtonItem>
                        </Tooltip>
                        {record.estado !== 0 &&
                            <Tooltip title="Editar lote" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                <ButtonItem
                                    icon={<EditOutlined />}
                                    size="small"
                                    type="default"
                                    cyan
                                    key={index.toString()}
                                    onClick={() => this.editarLote(value._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        }
                        {this.props.permitirBajaLotesReemplazoVentas && record.estado === 1 &&
                            <Tooltip title="Dar de baja lote" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                <ButtonItem
                                    icon={<StopOutlined />}
                                    size="small"
                                    type="default"
                                    rojo
                                    key={index.toString()}
                                    onClick={() => this.abrirBajaLote(value._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        }
                        {this.props.permitirBajaLotesReemplazoVentas && record.dadoDeBaja &&
                            <Tooltip title="Ventas pendientes de reemplazo" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                <ButtonItem
                                    icon={<SwapOutlined />}
                                    size="small"
                                    type="default"
                                    naranja
                                    key={index.toString()}
                                    onClick={() => this.abrirBajaLote(value._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        }

                    </Space>
                ),
                width: "9%",
            }
        ];
        return (
            <>
                <style>{cssFilasCaducidad}</style>
                <PageHeader
                    onBack={() => this.atras()}
                    title={(this.props.taxidermia ? "Animales - Insumo" : "Lotes - Insumo")}
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <Space style={{ width: "100%", minWidth: 700 }}>
                            {window.innerWidth > 1000 &&
                                <SegmentedItem
                                    options={[
                                        { label: 'Activos', value: 1 },
                                        { label: 'Ocupados', value: 2 },
                                        { label: 'Todos', value: 3 },
                                        ...(this.props.permitirBajaLotesReemplazoVentas ? [{ label: 'Dados de baja', value: 4 }] : []),
                                    ]}
                                    onChange={(value) => {
                                        this.consultarLotesInsumo(value)
                                        this.setState({ valor: value })
                                    }}
                                    value={this.state.valor}
                                />
                            }
                            <SelectInsumosItem
                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                headersToken={this.props.headersToken}
                                onChange={(value) => this.onChangeProyectoInsumo(value, this.state.proyectoId)}
                                value={this.state.insumoId}
                                autoFocus
                                dropdownMatchSelectWidth={600}
                                width={550}
                                placeholder="Insumo"
                                tiposInsumos="inventariables"
                            />
                            <SelectItem
                                placeholder="Proyecto"
                                width={150}
                                onChange={(value) => this.onChangeProyectoInsumo(this.state.insumoId, value)}
                                value={this.state.proyectoId}
                            >
                                <Option value={0}>Todos</Option>
                                {this.state.objetoProyectos}
                            </SelectItem>
                        </Space>
                    }
                />
                <TableItem
                    size="small"
                    dataSource={this.state.todasLotes}
                    columns={columns}
                    pagination={false}
                    loading={this.state.loading}
                    rowClassName={(record, index) => {
                        const indice = this.getIndiceRangoCaducidad(record.caducidad);
                        if (indice || indice === 0) {
                            return `fila-caducidad-lote-producto-${indice}`;
                        } else {
                            if (index % 2 === 0) {
                                return 'zebra-gris'
                            }
                            return 'default'
                        }
                    }}
                    onRow={(record, rowIndex) => {
                        return {
                            onDoubleClick: (event) => {
                                this.verLote(record._id);
                            },
                        };
                    }}
                    estadosLeyenda={estadosLeyendaDinamicos}
                    noPonerClase
                />
                <VerLote
                    visible={this.state.modalVerLote}
                    cerrarVerLote={this.cerrarVerLote.bind(this)}
                    loteId={this.state.modalVerLoteId}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                />
                <EditarLote
                    visible={this.state.modalEditarLote}
                    cerrarEditarLote={this.cerrarEditarLote.bind(this)}
                    loteId={this.state.modalEditarLoteId}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                />
                <ModalEtiquetasLote
                    visible={this.state.modalEtiquetasLote}
                    loteId={this.state.modalEtiquetasLoteId}
                    loteNumero={this.state.modalEtiquetasLoteNumero}
                    onCancel={this.cerrarEtiquetasLote.bind(this)}
                />
                {this.props.permitirBajaLotesReemplazoVentas &&
                    <ModalBajaLote
                        visible={this.state.modalBajaLote}
                        loteId={this.state.modalBajaLoteId}
                        onCancel={this.cerrarBajaLote.bind(this)}
                    />
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        taxidermia: state.empresa.taxidermia,
        permitirBajaLotesReemplazoVentas: state.empresa.permitirBajaLotesReemplazoVentas,
    };
};

export default connect(mapStateToProps)(LotesProducto);
